import Cookies from "js-cookie";
let browserDetection = require('browser-detection/src/browser-detection');
browserDetection({
  addClasses: true
});

document.addEventListener('DOMContentLoaded', () => {
  /* Announcement */
  // setInterval(() => {
  //   $(".offer")
  //     .first()
  //     .slideUp(function() {
  //       $(this)
  //         .appendTo($(this).parent())
  //         .css({ overflow: "", display: "" });
  //     });
  // }, 4400);

  // Close Announcement
  const closeAnnouncement = document.querySelector("[data-announcement-close]");
  if (closeAnnouncement) {
    closeAnnouncement.addEventListener("click", () => {
      Cookies.set("_close_announcment", "1", { expires: 30 });
      closeAnnouncement.parentElement.classList.add("hidden");
    });
  }
  if (
    Cookies.get("_close_announcment") &&
    Cookies.get("_close_announcment") == "1"
  ) {
    if (closeAnnouncement) {
      closeAnnouncement.parentElement.classList.add("hidden");
    }
  }
});
